import { useMutation } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import { apiV1Endpoint } from "../../../../api/v1";
import { ApiResponse } from "../../../../types/api-response";

type UpdateCustomFieldsRequest = {
  propertyId: string;
  unitId?: string;
  payload: { financialDimensions: unknown };
};

const updateFinancialDimensionsRequest = async ({ propertyId, unitId, payload }: UpdateCustomFieldsRequest) => {
  const url = `${apiV1Endpoint}/property/financialdimensions/${propertyId}`;

  const response = await axios.patch<ApiResponse>(url, payload, {
    params: unitId ? { unitId } : undefined,
  });
  return response.data.result;
};

type UseUpdateFinancialDimensionsOptions = {
  onSuccess?: () => void;
  onError?: (error: AxiosError<ApiResponse>) => void;
};

export const useUpdateFinancialDimensions = (options: UseUpdateFinancialDimensionsOptions = {}) => {
  const { onSuccess, onError } = options;

  const { mutateAsync, ...rest } = useMutation({
    mutationFn: updateFinancialDimensionsRequest,
    onSuccess,
    onError,
  });

  return {
    ...rest,
    updateFinancialDimensionsRequest: mutateAsync,
  };
};
